import { ICreateProjetoArquivoUseCase } from "../../../presentation/useCases/create/create_projeto_arquivo_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";


export class CreateProjetoArquivoUseCase implements ICreateProjetoArquivoUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async createProjetoArquivo(IdProjeto: number,    
  Descricao: string | null,    
  Nome: string | null,           
  Arquivo: File | null): Promise<void> {
    return await this.repository.createProjetoArquivo(IdProjeto, Descricao, Nome, Arquivo);
  }
}
